import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.811 7.664-4.19-4.189a1.5 1.5 0 0 0-2.121 0L3.94 15.035a1.5 1.5 0 0 0-.44 1.061v4.19a1.5 1.5 0 0 0 1.5 1.5h15.75a.75.75 0 0 0 0-1.5h-9.439l10.5-10.5a1.5 1.5 0 0 0 0-2.122M9.19 20.286H5v-4.19l8.25-8.25 4.19 4.19zm9.31-9.31-4.189-4.19 2.25-2.25 4.189 4.19z"
    }, null, -1)
  ])))
}
export default { render: render }